const mutations = {
  /**
   * Set the endpoints property on state
   * with endpoints parameter.
   *
   * @param state
   * @param endpoints
   */
  setEndpoints(state, endpoints) {
    state.endpoints = endpoints;
  },

  /**
   * Set the endpoint property on state
   * with endpoint parameter.
   *
   * @param state
   * @param endpoint
   */
  setEndpoint(state, endpoint) {
    state.endpoint = endpoint;
  },
};

export default mutations;
